export default __webpack_public_path__ + "static/parp_eng-803a56dc05fc5054fdee69a442c4b4a3.png";